import { Alert, Button } from '@modulor/react';
import type { ReactNode } from 'react';

interface SessionExpiredModalProps {
  isOpen: boolean;
  title?: ReactNode;
  content?: ReactNode;
  label: string | ReactNode;
  onClick: () => unknown;
}

export const SessionExpiredModal = (props: SessionExpiredModalProps) => {
  const { isOpen, onClick, title, content, label } = props;
  return (
    <Alert
      open={isOpen}
      title={title}
      content={content}
      vertical
      dataTestId="sessionExpired-modal"
      data-title-translation-key="PH.POPUP.SESSION_EXPIRED.TITLE"
      data-body-translation-key="PH.POPUP.SESSION_EXPIRED.BODY"
      data-label-translation-key="PH.BUTTON.REFRESH"
    >
      <Button dataTestId="sessionExpired-modal-button" variant="primary" onClick={onClick}>
        {label}
      </Button>
    </Alert>
  );
};
